import * as React from 'react';

interface SelectProps<T extends string|number, K extends string|number> {
    value: T;
    onChange: (val: T) => any;
    options: { [T in K]: string };
}

export function Select <T extends string|number, K extends string|number = T>({
    value,
    onChange,
    options,
}: SelectProps<T, K>) {
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(e.target.value as T);
    };

    return (
        <div className="select-container">
            <select className="field" value={value} onChange={handleChange}>
                {Object.entries(options).map(([val, label]) => (
                    <option key={val} value={val}>{label}</option>
                ))}
            </select>
        </div>
    );
}
